module.exports = __webpack_public_path__ + "static/media/facebook.b5d662bc.svg";